import { render } from "./RectangularButton.vue?vue&type=template&id=b4b8067c&scoped=true"
import script from "./RectangularButton.vue?vue&type=script&lang=js"
export * from "./RectangularButton.vue?vue&type=script&lang=js"

import "./RectangularButton.vue?vue&type=style&index=0&id=b4b8067c&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b8067c"]])

export default __exports__